import React from "react";
import MainBanner from "../../../components/MainComponents/MainBanner";
import { bannerTestinomialDetailImage, bannerTestinomialImage, mainTitle } from "../../../config";
import Footer from "../../../components/MainComponents/Footer";
import TestinomialDetailSection from "../../../components/TestinomialsComponents/TestinomialDetail";

// const testimonialData = {
//   name: "Sudesh Kaushik",
//   shortIntro: "From Chronic Pain to a Renewed Life - Sudesh's Journey",
//   title: "My Journey Towards a Pain-Free Life",
//   fullStory: `After years of suffering from chronic back pain, I had almost given up hope. I had tried numerous treatments with minimal relief. 
//     But after discovering FlexifyMe and working closely with Dr. Disha, I began to see improvements I hadn’t experienced in years. 
//     Initially, I was hesitant to start another physiotherapy regimen, but Dr. Disha’s personalized approach changed everything. 
//     Within weeks, my pain was significantly reduced, and I found myself able to engage in activities I had long forgotten about.`,
//   image: "path_to_customer_image.jpg", // Image path of the customer
//   timeline: [
//     {
//       title: "First Consultation",
//       description:
//         "During my first consultation, Dr. Disha thoroughly examined my condition and assured me that there was a path to recovery.",
//       icon: "🩺",
//     },
//     {
//       title: "First Month of Treatment",
//       description:
//         "I started seeing noticeable improvement in my mobility and a reduction in pain levels after the first few sessions.",
//       icon: "💪",
//     },
//     {
//       title: "Continued Progress",
//       description:
//         "As the months went by, I could do more activities, including going on morning walks and playing with my children.",
//       icon: "🏃",
//     },
//     {
//       title: "Achieving My Goals",
//       description:
//         "By the end of my treatment, I was back to living a pain-free life and could do things that had seemed impossible.",
//       icon: "🎉",
//     },
//   ],
//   expertName: "Dr. Paul Sidhu",
//   expertQuote:
//     "Sudesh’s recovery is a great testament to the power of persistence and personalized care. His improvement reflects the incredible dedication he put into his healing journey.",
//   expertImage: require("../../../assets/images/doctor-6.jpg"), // Image path of the expert
//   relatedStories: [
//     {
//       name: "Preethi Agarwal",
//       snippet:
//         "I had been suffering from back pain for years, but FlexifyMe gave me the help I needed...",
//       link: "#",
//     },
//     {
//       name: "Sumi Patty",
//       snippet:
//         "Dr. Disha’s sessions changed my life. I was able to recover from severe back pain that had been plaguing me...",
//       link: "#",
//     },
//     {
//       name: "Richa Jaiswal",
//       snippet:
//         "First of all, I would like to thank the FlexifyMe app for connecting me to the best physiotherapist...",
//       link: "#",
//     },
//   ],
// };

const TestinomialDetailPage = () => {
  return (
    <div className="bg-background">
      <MainBanner
       
        bannerTitle={mainTitle}
        banenrHeadline={"An Inspiring Journey to Recovery"}
        showButton={false}
        bannerDescription={
          "Dive deep into their recovery stories and see how they found a new lease on life"
        }
      />
      {/* <TestinomialDetailSection testimonialData = {testimonialData}/> */}
      <Footer />
    </div>
  );
};

export default TestinomialDetailPage;
